import React, { useEffect } from 'react';
import {handleClickLinks} from '../includes/utils';
import PropTypes from "prop-types";

export default function CsfFournisseurHomeMenu({urlGestion, urlDelegation, urlRequestRecognition, role}) {
  useEffect(() => {
    // On page load, if the url includes the param 'modalModification=true', show the modification modal
    const modalParam = window.location.href.includes('?modalModification=true');
    const modalSelector = $('#eventModificationModal');
    if (modalParam && modalSelector) {
      modalSelector.modal('show');
      // Reset param in url if modal was shown
      const urlWithoutModalParam = window.location.href.replace('?modalModification=true','');
      window.history.replaceState(null,'', urlWithoutModalParam);
    }
  }, []);

  return (
    <aside className="aside secondary">
      <button className="button" onClick={() => handleClickLinks(urlRequestRecognition)}>
        <img src="/themes/custom/tink/dist/assets/supplier-new.svg" alt=""/>
        <span>{window.Drupal.t('fournisseur.home.menu.request.label')}</span>
      </button>
      <button className="button" data-toggle="modal" data-target="#recognitionRenewalModal">
        <img src="/themes/custom/tink/dist/assets/supplier-edit.svg" alt=""/>
        <span>{window.Drupal.t('fournisseur.home.menu.renewal.label')}</span>
      </button>
      <button className="button" data-toggle="modal" data-target="#eventRecognitionModal">
        <img src="/themes/custom/tink/dist/assets/supplier-new.svg" alt=""/>
        <span>{window.Drupal.t('fournisseur.home.menu.events.label')}</span>
      </button>
      <button className="button" data-toggle="modal" data-target="#eventModificationModal">
        <img src="/themes/custom/tink/dist/assets/supplier-edit.svg" alt=""/>
        <span>{window.Drupal.t('fournisseur.home.menu.modification.label')}</span>
      </button>
      <button className="button" disabled={role === 1} onClick={() => handleClickLinks(urlGestion)}>
        <img src="/themes/custom/tink/dist/assets/supplier-trainer.svg" alt=""/>
        <span>{window.Drupal.t('fournisseur.home.menu.management.label')}</span>
      </button>
      <button className="button" disabled={role < 2} onClick={() => handleClickLinks(urlDelegation)}>
        <img src="/themes/custom/tink/dist/assets/supplier-access.svg" alt=""/>
        <span>{window.Drupal.t('fournisseur.home.menu.access_right.label')}</span>
      </button>
    </aside>
  )
}

CsfFournisseurHomeMenu.propTypes = {
  urlGestion: PropTypes.string,
  urlDelegation: PropTypes.string,
  urlRequestRecognition: PropTypes.string,
  role: PropTypes.number
};
